import { useContext, useState } from "react";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { Alert } from "reactstrap";
import BjelinButton from "../BjelinButton";
import apiService from "../../services/apiService";
import AccountTypeField from "./fields/AccountTypeField";
import { accountTypes } from "../../config/accountTypes";
import NewsletterField from "./fields/NewsletterField";
import EmailField from "./fields/EmailField";
import BusinessFields from "./fields/BusinessFields";
import NameFields from "./fields/NameFields";
import PasswordField from "./fields/PasswordField";
import ErrorCodes from "../../config/ErrorCodes";
import { UserContext } from "../../functional-components/UserContext";
import { gtmSendEvent } from "../../utils/GTMUtils";

const CreateUserForm = ({ close }) => {
  const t = useBjelinTranslations();
  const userContext = useContext(UserContext);
  const [companyName, setCompanyName] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [password, setPassword] = useState("");
  const [newsletter, setNewsletter] = useState(false);
  const [accountType, setAccountType] = useState(accountTypes.privateAccount);
  const changeAccountType = accountType => {
    setAccountType(accountType);
    setGlobalError(false);
  };
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [globalError, setGlobalError] = useState(false);
  const resetAlerts = () => {
    setErrors({});
    setGlobalError(false);
  };
  const createUser = () => {
    if (!loading) {
      resetAlerts();
      if (email !== email2) {
        setErrors({ email2: ErrorCodes.EMAIL_NOT_REPEATED });
      } else {
        setLoading(true);
        apiService
          .createUser(
            accountType,
            password,
            email,
            firstName,
            lastName,
            companyName,
            vatNumber,
            newsletter
          )
          .then(result => {
            userContext.signInWithCustomToken(result.data.token).then(() => {
              gtmSendEvent({ event: "sign_up", method: "website" });
              setLoading(false);
              close();
            });
          })
          .catch(errorResult => {
            const errorData = errorResult.response.data;
            console.error("createUser error", errorData);
            setErrors(errorData.fieldErrors || {});
            if (errorData.globalError || !errorData.fieldErrors) {
              setGlobalError(
                t(errorData.globalError || ErrorCodes.FORM_CONTAINS_ERRORS)
              );
            }
            setLoading(false);
          });
      }
    }
  };
  return (
    <div>
      <h1>{t("sign.up")}</h1>
      <AccountTypeField
        accountType={accountType}
        callback={changeAccountType}
      />
      {accountType === accountTypes.businessAccount && (
        <BusinessFields
          companyName={companyName}
          companyNameCallback={setCompanyName}
          vatNumber={vatNumber}
          vatNumberCallback={setVatNumber}
          errors={errors}
          required={true}
        />
      )}
      <NameFields
        firstName={firstName}
        firstNameCallback={setFirstName}
        lastName={lastName}
        lastNameCallback={setLastName}
        errors={errors}
        required={true}
      />
      <EmailField
        email={email}
        callback={setEmail}
        errors={errors}
        required={true}
      />
      <EmailField
        email={email2}
        callback={setEmail2}
        errors={errors}
        label={"confirm.email.address"}
        field={"email2"}
        validate={false}
      />
      <PasswordField
        password={password}
        callback={setPassword}
        errors={errors}
        autoComplete={"new-password"}
        required={true}
      />
      <NewsletterField newsletter={newsletter} callback={setNewsletter} />
      {globalError && (
        <Alert color={"danger"} className={"mt-2"}>
          {globalError}
        </Alert>
      )}
      <BjelinButton
        loading={loading}
        color={"primary"}
        className={"me-2"}
        onClick={createUser}
      >
        {t("create.account")}
      </BjelinButton>
      <BjelinButton color={"bjelin-darkgrey"} onClick={close}>
        {t("cancel")}
      </BjelinButton>
    </div>
  );
};

export default CreateUserForm;
